import { render, staticRenderFns } from "./TasinirBilgileriList.vue?vue&type=template&id=34f8c09a"
import script from "./TasinirBilgileriList.vue?vue&type=script&lang=ts"
export * from "./TasinirBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports